// extracted by mini-css-extract-plugin
export default {"edit-group-form":"styles__edit-group-form___Ao7vo","half-width-left":"styles__half-width-left____0KDW","readOnly":"styles__readOnly____Px_G"};